import { render, staticRenderFns } from "./DadosForm.vue?vue&type=template&id=8655a930&scoped=true"
import script from "./DadosForm.vue?vue&type=script&lang=js"
export * from "./DadosForm.vue?vue&type=script&lang=js"
import style0 from "./DadosForm.vue?vue&type=style&index=0&id=8655a930&prod&lang=css"
import style1 from "./DadosForm.vue?vue&type=style&index=1&id=8655a930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8655a930",
  null
  
)

export default component.exports